<template>
	<div>
		<div class="mb-2 pd-0">
			<v-col class="pt-0" v-if="shouldDisplaySingle ? getNotifications.length > 2 : getNotifications.length > 0">
				<v-tooltip top>
					<template v-slot:activator="{ on }">
						<v-btn
							x-small
							class="float-right mr-4 deleteAll"
							@click="deleteAllNotifications()"
							icon
							v-on="on"
						>
							<v-icon>fa-regular fa-thin fa-trash-can</v-icon>
						</v-btn>
					</template>
					<span>Clear all notifications</span>
				</v-tooltip>
				<v-tooltip top>
					<template v-slot:activator="{ on }">
						<v-btn
							x-small
							class="float-right mr-5 markAll"
							@click="markAllAsRead()"
							icon
							v-on="on"
						>
							<v-icon>fa-regular fa-envelope-open</v-icon>
						</v-btn>
					</template>
					<span>Mark all as read</span>
				</v-tooltip>
			</v-col>
		</div>
		<div v-if="shouldDisplaySingle ? (getNotifications.length > 2) : (getNotifications.length > 0)">
			<v-list>
				<template v-for="(item, index) in visiblePages">
					<v-subheader
						v-if="item.header"
						:key="item.header"
						v-text="item.header"
					></v-subheader>

					<v-divider
						v-else-if="item.divider"
						:key="index"
						:inset="item.inset"
					></v-divider>

					<v-list-item
						v-bind:class="{ 'new-notification': !item.seen }"
						class="rounded my-1"
						v-else
						:key="item.title"
					>
						<v-list-item-avatar color="primary" size="40">
							<v-img v-if="item.logo" :src="item.logo" width="300" />
							<v-icon v-else size="20" class="white--text">fas fa-{{ item.icon }}</v-icon>
						</v-list-item-avatar>

						<v-list-item-content
							@click="handleNotification(item, index)"
							v-if="isPortalPage"
							style="margin-bottom: 0;"
						>
							<v-list-item-title>
								{{ item.message }}
								<span style="margin-left: 10px; font-size: 14px; color: #696969">
									- Received {{
										$moment(item.sent).fromNow() /*.format("DD/MM/YYYY HH:mm:ss")*/
									}}
								</span>
							</v-list-item-title>
						</v-list-item-content>
						<v-list-item-content
							@click="handleNotification(item, index)"
							v-else
						>
							<v-list-item-title>
								{{ item.message }}
							</v-list-item-title>
							<v-list-item-subtitle>
								Received
								{{
									$moment(
										item.sent
									).fromNow() /*.format("DD/MM/YYYY HH:mm:ss")*/
								}}
							</v-list-item-subtitle>
						</v-list-item-content>
						<v-list-item-action v-if="getURL(item) != null">
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn icon v-bind="attrs" v-on="on" @click="handleNotification(item, index)">
										<v-icon color="primary" size="18">fas fa-external-link-alt</v-icon>
									</v-btn>
								</template>
								<span>Click here to go Inside</span>
							</v-tooltip>
						</v-list-item-action>
						<v-list-item-action class="ma-1">
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn icon class="removeIcon">
										<v-icon
											size="18"
											v-bind="attrs" 
											v-on="on"
											@click="deleteNotification({ index, id: item.id })"
											color="grey lighten-2"
											>fas fa-times</v-icon
										>
									</v-btn>
								</template>
								<span>Remove</span>
							</v-tooltip>
						</v-list-item-action>
					</v-list-item>
				</template>
			</v-list>

			<v-pagination
				v-if="isPortalPage"
				style="float: right;"
				v-model="page"
				:length="Math.ceil(notifications.length / perPage)"
				circle
				:total-visible="5"
			>
			</v-pagination>
			<v-pagination
				v-else
				v-model="page"
				:length="Math.ceil(notifications.length / perPage)"
				circle
				:total-visible="5"
			>
			</v-pagination>
		</div>
		<v-card
			elevation="0"
			outlined
			style="background-color: transparent"
			class="rounded-lg mt-4"
			v-else-if="getNotifications.length > 0"
		>
			<v-card-actions>
				<v-spacer />
				<v-btn
					v-if="getURL(getNotifications[0]) != null"
					icon
					@click="handleNotification(getNotifications[0], 0)"
				>
					<v-icon color="primary" size="18">fas fa-external-link-alt</v-icon>
				</v-btn>
				<v-btn
					right
					icon
					small
					@click="deleteNotification({ index: 0, id: getNotifications[0].id })"
					><v-icon>fas fa-times</v-icon></v-btn
				>
			</v-card-actions>
			<div class="text-center mb-9" style="min-height: 120px;">
				<v-avatar class="float-left d-none d-md-block" style="position:absolute; left:30px;" color="grey" size="120">
					<v-img v-if="getNotifications[0].logo" width="300" :src="getNotifications[0].logo" />
					<v-icon v-else size="60">fas fa-building</v-icon>
				</v-avatar>
				<h2>{{ getNotifications[0].message }}</h2>
				<div class="font-italic">
					{{
						$moment(
							getNotifications[0].sent
						).fromNow() /*.format("DD/MM/YYYY HH:mm:ss")*/
					}}
				</div>
				<v-btn
					v-if="!!getCTA(getNotifications[0].resourceID) && getURL(getNotifications[0]) != null"
					:color="getCTA(getNotifications[0].resourceID).color"
					class="mt-5"
					dark
					elevation="1"
					x-large
					@click="handleNotification(getNotifications[0], 0)"
				>
					{{ getCTA(getNotifications[0].resourceID).title }}
				</v-btn>
			</div>
		</v-card>
		<div v-else class="text-center mb-9, no-notification">
			<v-avatar class="float-left d-none d-md-block" color="grey" size="120">
				<template v-if="logoUrl">
					<v-img 
					class="mx-auto mt-5"
					:src="logoUrl" 
					width="50%" 
					height="100px"
					/>
				</template>
				<template v-else>
					<v-icon size="60">fas fa-building</v-icon>
				</template>
			</v-avatar>
			<h2>Welcome to the orixe.tech platform!</h2>
			<br>
			<v-btn 
				color="primary"
				
			><a target="_blank" href="https://www.orixe.eu/duediligance" style="text-decoration: none; color: white">Supply Chain Due Diligance with Orixe</a></v-btn>
			<!-- <h3 class="text-center font-weight-medium">
				There are no new notifications<br />
				<v-icon color="secondary">far fa-smile-beam</v-icon>
			</h3> -->
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex"
import InvitationcodeAPI from "../api/connections/invitationcodes"

export default {
	name: "NotificationsList",
	props: {
		shouldMarkAsRead: Boolean,
		shouldDisplaySingle: {
			type: Boolean,
			default: false
		},
		maxNotifications: {
			type: Number,
			default: null
		},
		isPortalPage: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			logoUrl: null,
			page: 1,
			perPage: this.maxNotifications || 8
		}
	},
	computed: {
		...mapState("notifications/notifications", {
			notifications: state => state.notifications
		}),
		...mapGetters("notifications/notifications", [
			"getNotifications"
			// ...
		]),
		visiblePages() {
			return this.getNotifications.slice(
				(this.page - 1) * this.perPage,
				this.page * this.perPage - 1
			)
		}
	},
	beforeDestroy() {
		if (this.shouldMarkAsRead) {
			this.markAsRead()
		}
	},
	created() {
		this.loadNotifications({})
	},
	mounted() {
		this.getclientlogo()
	},
	methods: {
		...mapActions("notifications/notifications", [
			"markAllAsRead",
			"deleteNotification",
			"deleteAllNotifications",
			"loadNotifications",
			"markAsRead"
		]),
		...mapActions("connections/invitationcodes", ["setInvitationCode"]),
		getclientlogo() {
			InvitationcodeAPI.getClientdata(this.invitationcode)
				.then((result) => {
					this.logoUrl = result[1]
				})
		},
		handleNotification(item, index){
			if (!item) {
				return
			}
			const url = this.getURL(item)
			if (url) {
				this.$router.push(url).catch(() => {})
			}
			this.markAsRead({ index, id: item.id })
		},
		getURL(item) {
			if (!item || !item.resourceID) {
				return null
			}
			let parts = String(item.resourceID).split("-")
			if (parts.length < 2) {
				return null
			}
			let prefix = parts[0]
			let value = parts[1]
			if ((prefix === "OAR" && item.message && item.message.includes("Onsite-Audit Template Request")) || (prefix === "OAR" && item.message && item.message.includes("has checked your Onsite Template comment!"))) {
				return `/auditonsite/onsiteauditor`
			}
			
			if (prefix === "OAU" && item.message.includes("sent you a new Onsite-Audit Request!") || (prefix === "OAU" && item.message && item.message.includes("Improvements have been submitted"))) {
				return `/auditonsite/onsitesupplier`
			}

			if (prefix === "OAR" && item.message.includes("added a comment for your Onsite-Audit Template")) {
				return `/auditonsite/onsitetemplates/${value}`
			}

			if (prefix === "OAR" && item.message.includes("approved your Onsite Template!")) {
				return `/auditonsite/onsitedashboard`
			}

			if (item.message && item.message.includes("sent the onsite schedule")) {
				return `/auditonsite/onsitesupplier`
			}

			switch (prefix) {
			case "AR":
				return `/audit/submitter/${value}`
			case "OAR":
				return `/auditonsite/onsiteauditor/${value}`
			case "FAR":
				return `/auditflowdown/flowdownsubmitter/${value}`
			case "AU":
				return `/audit/audits/${value}`
			case "OAU":
				return `/auditonsite/onsiteaudits/${value}`
			case "FAU":
				return `/auditflowdown/flowdownaudits/${value}`
			case "CO":
				if (item.message && item.message.includes("KPI performance")) {
					return `/connections/${value}?kpiPerformance=1`
				}
				return `/connections/${value}`
			case "TX":
				return `/trace/transactions/${value}`
			case "TC":
				return null
			case "CSR":
				return `/csr`
			case "NIS":
				return `/nis`
			case "POR":
				// Legacy NIS invites used Portal resource IDs
				if (item.message && item.message.includes("NIS Cyber Security Assessment")) {
					return `/nis`
				}
				return null
			default:
				return null
			}
		},
		getCTA(resourceID) {
			let parts = resourceID.split("-")
			if (parts.length < 2) {
				return null
			}
			let prefix = parts[0]
			switch (prefix) {
			case "AR":
				return {title: "Fill Out Audit", color: "orangeButton"}
			case "FAR":
				return {title: "Fill Out Flow-Down Audit", color: "orangeButton"}
			case "OAR":
				return {title: "Approve Onsite Template", color: "orangeButton"}
			case "OAU":
				return {title: "View Request", color: "orangeButton"}
			case "AU":
				return {title: "View Audit", color: "primary"}
			case "FAU":
				return {title: "View Audit Flow-Down", color: "primary"}
			case "CO":
				return {title: "View Connections", color: "connections"}
			case "TX":
				return {title: "View Transaction", color: "orangeButton"}
			case "TC":
				return {title: "View Transaction Comment", color: "orangeButton"}
			case "CSR":
				return {title: "View Sustainability", color: "sustainability"}
			case "NIS":
				return {title: "Fill Out NIS Survey", color: "nis"}
			default:
				return null
			}
		}
	}
}
</script>

<style scoped>
.new-notification {
	border: 1px green solid;
	background: #00800006;
}

.v-sheet {
	background: transparent;
}

.v-list {
	background: transparent;
}

.removeIcon:hover{
	background: #227e85;
}

.no-notification{
	text-align: center;
    border: 2px solid #ccc;
    padding: 50px;
    border-radius: 10px;
}

.deleteAll:hover{
	padding: 15px;
	background: #227e85;
	color: #fff;
}
.markAll:hover{
	padding: 15px;
	background: #227e85;
	color: #fff;
}
</style>
